<template>
  <b-modal
    id="modal-trading-expert-mode-investor"
    hide-footer
    hide-header
    size="lg"
    ok-only
  >
    <div class="modal-create-conditions">
      <div class="row">
        <div class="col-md-6">
          <h3 class="modal-title">Trading Expert mode</h3>
        </div>
        <div class="col-md-6 text-right">
          <b-button class="mb-2 mr-2" @click.prevent="showModalBalances"
            >Balances</b-button
          >
          <span
            style="font-size: 22px"
            class="mr-2"
            v-b-tooltip.hover
            title="Config conditions"
            @click="showCondidion"
          >
            <b-icon-gear></b-icon-gear>
          </span>
        </div>
      </div>
    </div>
    <div class="modal-body px-0 pb-0">
      <div class="row">
        <div class="col-md-4 mb-2">
          <div class="content px-0 item-active-config">
            <label>Order type</label>
            <div class="row px-2" style="margin-top: 0px">
              <div class="col-md-12 px-2">
                <select
                  class="form-control"
                  v-model="order.order_type"
                  @input="$v.order.order_type.$touch()"
                >
                  <option value="limit">Limit</option>
                  <option value="market">Market</option>
                </select>
                <div v-if="$v.order.order_type.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.order.order_type.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-2">
          <div class="content px-0 item-active-config">
            <label>Exchange</label>
            <div class="row px-2" style="margin-top: 0px">
              <div class="col-md-12 px-2">
                <select
                  class="form-control"
                  v-model="order.exchange"
                  @input="$v.order.exchange.$touch()"
                >
                  <option value="binance">Binance</option>
                </select>
                <div v-if="$v.order.exchange.$dirty">
                  <b-form-invalid-feedback :state="$v.order.exchange.required">
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-2">
          <div class="content px-0 item-active-config">
            <label>Order open close tolerance</label>
            <input
              type="number"
              pattern="[0-9]"
              min="1"
              max="100"
              class="form-control"
              v-model="order.order_open_close_tolerance"
              @input="$v.order.order_open_close_tolerance.$touch()"
            />
            <div v-if="$v.order.order_open_close_tolerance.$dirty">
              <b-form-invalid-feedback
                :state="$v.order.order_open_close_tolerance.required"
              >
                Required Field
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-2 mt-4" v-if="conditions.length > 0">
          <label>Conditions</label>
          <div class="row">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control d-block mb-2"
                v-model="filterValue"
                placeholder="Filter condition..."
              />
            </div>
            <div
              class="col-md-12"
              v-for="condition in conditions"
              :key="condition.token"
            >
              <ViewJson :jsonData="condition" :filter="filterValue2" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-footer p-0"
      style="background-color: #232429; display: flex; justify-content: start"
    >
      <b-button
        variant="success"
        class="mr-2"
        @click.prevent="handleCreateOrder('buy')"
        >Send operation</b-button
      >
    </div>
    <ShowBalances :showTitle="false" />
    <ConfigureConditions
      ref="ConfigureConditions"
      :showSignal="false"
      :showBaseConfiguration="true"
      @handleConditions="handleConditions"
    />
  </b-modal>
</template>
<script>
import ShowBalances from "@/components/pages/investors/trading-expert/ShowBalances";
import ConfigureConditions from "@/components/pages/investors/trading-expert/ConfigureConditions";
import { required } from "vuelidate/lib/validators";
import ViewJson from "@/components/commons/ViewJson";

export default {
  name: "TradingExpertModeInvestor",
  components: {
    ShowBalances,
    ConfigureConditions,
    ViewJson,
  },
  validations: {
    order: {
      order_open_close_tolerance: { required },
      order_type: { required },
      exchange: { required },
    },
  },
  created() {
    this.validInvestor();
  },
  mounted() {},
  data() {
    return {
      isFutures: false,
      order: {
        order_open_close_tolerance: 5,
        order_type: "limit",
        error: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="20" height="20" rx="10" fill="#DC3545" fill-opacity="0.3"/>
		<path d="M12.4999 7.49992C12.4218 7.42181 12.3158 7.37793 12.2053 7.37793C12.0949 7.37793 11.9889 7.42181 11.9108 7.49992L9.99992 9.41076L8.08909 7.49992C8.01095 7.42181 7.90499 7.37793 7.79451 7.37793C7.68402 7.37793 7.57806 7.42181 7.49992 7.49992C7.42181 7.57806 7.37793 7.68402 7.37793 7.79451C7.37793 7.90499 7.42181 8.01095 7.49992 8.08909L9.41076 9.99992L7.49992 11.9108C7.42181 11.9889 7.37793 12.0949 7.37793 12.2053C7.37793 12.3158 7.42181 12.4218 7.49992 12.4999C7.57806 12.578 7.68402 12.6219 7.79451 12.6219C7.90499 12.6219 8.01095 12.578 8.08909 12.4999L9.99992 10.5891L11.9108 12.4999C11.9889 12.578 12.0949 12.6219 12.2053 12.6219C12.3158 12.6219 12.4218 12.578 12.4999 12.4999C12.578 12.4218 12.6219 12.3158 12.6219 12.2053C12.6219 12.0949 12.578 11.9889 12.4999 11.9108L10.5891 9.99992L12.4999 8.08909C12.578 8.01095 12.6219 7.90499 12.6219 7.79451C12.6219 7.68402 12.578 7.57806 12.4999 7.49992Z" fill="#1D1E25"/>
		</svg> Error`,
        exchange: "binance",
      },
      conditions: [],
      filterValue: "",
      filterValue2: "",
      investor: {},
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
          <g clip-path="url(#clip0_1634_940)">
          <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
          </g>
          <defs>
          <clipPath id="clip0_1634_940">
          <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
          </clipPath>
          </defs>
          </svg> Success`,
    };
  },
  methods: {
    validInvestor() {
      if (!this.$store.state.info_investor.info) {
        let interval = setInterval(() => {
          if (this.$store.state.info_investor.info) {
            clearInterval(interval);
            this.setInvestor();
          }
        }, 250);
      } else {
        this.setInvestor();
      }
    },
    setInvestor() {
      let investor = this.$store.state.info_investor.info;
      this.investor = investor;
      let configuration = JSON.parse(investor.investor.configurations);
      if (configuration.market_type.toLowerCase() === "futures") {
        this.isFutures = true;
      }
    },
    showModalConfigFutures() {
      this.$bvModal.show("modal-config-futures");
    },
    showModalBalances() {
      this.$bvModal.show("modal-balances");
    },
    showCondidion() {
      if (this.conditions.length == 1) {
        this.$refs.ConfigureConditions.resetConditions();
        this.$refs.ConfigureConditions.handleEditCondition(
          this.conditions[0],
          0
        );
      }
      this.$bvModal.show("modal-add-condition-v3");
    },
    handleConditions(value) {
      let new_values = [];
      value = JSON.parse(JSON.stringify(value));
      for (let i = 0; i < value.length; i++) {
        let condition = value[i];
        delete condition.signal_condition;
        delete condition.timeframes;
        delete condition.client_confirmation;
        new_values.push(condition);
      }
      this.conditions = [];
      this.conditions = new_values;
    },
    handleCreateOrder(side) {
      let base_configuration = this.conditions[0].base_configuration;
      let user = this.$store.state.info_investor.info;
      const data = {
        symbol: this.investor.investor.symbol,
        investor_token: this.investor.token,
        side: base_configuration.type,
        commission: base_configuration.comission,
        laverage: base_configuration.laverage / 100,
        loting: base_configuration.lot,
        is_real: user.investor.is_real,
        exchange: this.order.exchange,
        order_type: this.order.order_type,
        order_open_close_tolerance: this.order.order_open_close_tolerance,
      };
      if (this.conditions[0].open_condition) {
        data["open_conditions"] = JSON.stringify(
          this.conditions[0].open_condition
        );
      }
      if (this.conditions[0].close_condition) {
        data["close_conditions"] = JSON.stringify(
          this.conditions[0].close_condition
        );
      }
      if (this.conditions[0].close_condition_dynamic) {
        data["close_dynamic_conditions"] = JSON.stringify(
          this.conditions[0].close_condition_dynamic
        );
      }
      this.$http
        .server1("bwfs/admin/InvestorExpertPanel/create_an_order", data)
        .then((res) => {
          if (res.error) {
            this.$toastr.error(`${res.msg}`, `${this.error}`);
            return;
          }
          this.$toastr.success("Success send order.", `${this.success}`);

          this.$bvModal.hide("modal-trading-expert-mode-investor");
          this.conditions = [];
        })
        .catch((e) => {
          this.$toastr.error(`${e.message}`, `${this.error}`);
        });
    },
  },
};
</script>
